import { ChangeEvent, CSSProperties, MouseEvent, useRef, useState } from "react"
import { UploadEvidenceProps } from "./types"
import { Types } from "../../utils/enums"
import { useStyles } from "./styles"
import { newOrederEvidences } from "../../utils/constants/orderEvidencesType"
import { ExpandIcon } from "./components/expandIcon"
import { TypesEvidences } from "../../pages/reportFolio/pages/dashboard/pages/detail/components/typesEvidences"
import { galleryAndComment } from "./contants"
import { useTranslation } from "react-i18next"
import CustomAccordion from "../accordion"
import { UploadEvidenceTitle } from "./components"
import { saveAs } from 'file-saver'
import SnackSimple from "../snackbars/simple"
import SimpleModal from "../modal/simpleModal"
import { cancelUpload, deleteEvidenceUploaded, uploadEvidence } from "./methods"
import { Box } from "@mui/material"

export const UploadEvidence = ({ uploadName, evidencesDrawer, evidencesRequiredAreLoad, showRequireds, deletedEvidence, fakeDelete, setEvidencesDrawer, setEvidencesRequiredAreLoad, }: UploadEvidenceProps) => {
    const { t } = useTranslation()
    const styles = useStyles()
    const valueRef = useRef<Record<string, any> | null>(null)
    const [isLoadingConfirm, setIsLoadingConfirm] = useState(false)
    const fileRef = useRef<HTMLInputElement | null>(null)

    const [openModal, setOpenModal] = useState<{
        open: boolean
        title: string
        description?: string
        children?: JSX.Element
        removeCancel?: boolean
        method?: () => void
    }>({
        open: false,
        title: t('reportFolio.snackbar.areYouSureonDeleteThisFile'),
        description: '',
    })
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        type: Types.SUCCESS,
    })

    const seeFiles = ({ name, value }: { name: string; value: boolean }) => {
        const evidenceCopy = evidencesDrawer
        if (evidenceCopy?.value?.[name]) {
            evidenceCopy.value[name].seeFiles = value
        }
        setEvidencesDrawer({ ...evidenceCopy })
    }

    const addEvidences = ({ e, name, accept }: { e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>; name: string; accept?: string }) => {
        e.stopPropagation()
        if (fileRef?.current) {
            setEvidencesDrawer((prev) => ({
                ...prev,
                type: { ...prev?.type, equivalence: ['image/png', 'image/jpeg'], accept: accept ?? '', },
                name,
            }))
            const input = fileRef?.current
            setTimeout(() => { input?.click() }, 100)
        }
    }
    const addDignature = ({ e, name, accept }: { e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>; name: string; accept?: string }) => {
        setEvidencesDrawer((prev) => ({
            ...prev,
            type: { ...prev?.type, equivalence: ['image/png', 'image/jpeg'], accept: accept ?? '', },
            name,
        }))
    }
    const handleExpanded = (key: string, value: boolean) => {
        setEvidencesDrawer((prev) => ({
            ...prev,
            value: { ...prev.value, [key]: { ...(prev.value?.[key] ?? {}), expanded: value, }, },
        }))
    }

    const handleCancelUpload = async ({ key }: { key: string }) => {
        if (!!key && valueRef?.current?.[key]) {
            const { items } = cancelUpload({ evidenceState: evidencesDrawer.value, key })
            setEvidencesDrawer((prev) => ({ ...prev, value: items }))
            const refCopy = await valueRef?.current?.[key]
            refCopy?.abort()
        }
    }
    const handleLoad = async ({ url, name, nameFIle }: { url: string | File; name: string; nameFIle?: string }) => {

        if (typeof url === 'string') {
            var image = await fetch(url), imageBlog = await image.blob()
            saveAs(imageBlog, nameFIle)
            return;
        }

        getEvidences({ e: { target: { files: { 0: url } as any, } as any, } as any, name, isUpload: true, })
    }

    const handleCloseSnackbar = () => {
        setSnackbar((prev) => ({ ...prev, open: false, }))
    }
    const deleteEvidence = ({ index, isDelete, isString }: { index: number | string; isString?: boolean; isDelete?: (value: boolean) => void }) => {
        const { modal } = deleteEvidenceUploaded({
            nameFile: index,
            t,
            handleCloseModal,
            modal: openModal,
            setEvidencesDrawer,
            setEvidencesRequiredAreLoad,
            setIsLoadingConfirm,
            setSnackbar,
            uploadName,
            isDelete,
            isString,
            value: evidencesDrawer?.value,
            deletedEvidence,
            fakeDelete,
        })

        setOpenModal((prev) => ({ ...prev, ...modal }))
    }
    const handleCloseModal = () => {
        setIsLoadingConfirm(false)
        setOpenModal((prev) => ({ ...prev, open: false, }))
    }

    const handleComments = (payload: { value: string; name: string; type: string }) => {
        const { name, type, value } = payload
        const totalLength = Object.values(evidencesDrawer?.value?.[type]?.value ?? {})?.length + 1
        const minAmount = evidencesDrawer?.value?.[type]?.minAmount ?? 0

        setEvidencesRequiredAreLoad((prev) => ({ ...prev, [type]: !minAmount || (!!minAmount && totalLength > 0), }))
        setEvidencesDrawer((prev) => ({
            ...prev,
            value: {
                ...(prev.value ?? {}),
                [type]: {
                    ...(prev.value?.[type] ?? {}),
                    seeFiles: totalLength == prev.value?.[type]?.maxCount,
                    value: { ...(prev.value?.[type].value ?? {}), [name]: { name, url: value, }, },
                },
            },
        }))
    }
    const getEvidences = async ({ e, name, isUpload, isLoad }: { e: ChangeEvent<HTMLInputElement>; name?: string; isLoad?: (load: boolean) => void; isUpload?: boolean }) => {


        uploadEvidence({
            e,
            evidencesDrawer,
            fileRef,
            uploadName,
            valueRef,
            isUpload,
            name,
            accept: evidencesDrawer.type.accept,
            isLoad,
            setEvidencesDrawer,
            setEvidencesRequiredAreLoad,
            setOpenModal,
            setSnackbar,
        })
    }

    return (
        <Box sx={styles.container}>
            {Object.entries(evidencesDrawer?.value ?? {})
                ?.sort((a, b) => newOrederEvidences[a[0]] - newOrederEvidences[b[0]])
                ?.map(([key, item], index) => {
                    return (
                        <CustomAccordion
                            accordionProps={{ sx: !!showRequireds && (item?.minAmount ?? 0) > 0 && !evidencesRequiredAreLoad?.[key] ? styles.error : {} }}
                            expanded={!!item?.expanded}
                            onChange={(ex) => {
                                //seeFiles({ name: key, value: true })
                                handleExpanded(key, ex)
                            }}
                            key={index}
                            title={
                                <UploadEvidenceTitle
                                    handleExpanded={handleExpanded}
                                    name={key}
                                    seeFiles={seeFiles}
                                    canSeeFiles={item.seeFiles}
                                    customeTitle={item?.customeTitle as string}
                                    expanded={!!item.expanded}
                                    maxCount={item.maxCount}
                                    minAmount={item?.minAmount}
                                    size={item.size}
                                    value={item.value}
                                />
                            }
                            description={
                                <TypesEvidences
                                    customeKey={key}
                                    index={index}
                                    handleComments={handleComments}
                                    key={key}
                                    seeFiles={item?.seeFiles}
                                    isRequired={(item?.minAmount ?? 0) > 0}
                                    value={item.value}
                                    evidencesType={key}
                                    size={item.size}
                                    files={{
                                        deleteEvidence,
                                        handleCancelUpload,
                                        handleLoad,
                                        getEvidences,
                                    }}
                                />
                            }
                            expandIcon={
                                <ExpandIcon
                                    addEvidences={addEvidences}
                                    addDignature={addDignature}
                                    galleryAndComment={galleryAndComment}
                                    handleExpanded={handleExpanded}
                                    name={key}
                                    expand={!!item.expanded}
                                    seeFiles={seeFiles}
                                    value={item?.value}
                                    accept={item.accept}
                                    maxCount={item?.maxCount}
                                />
                            }
                        />
                    )
                })}

            <input
                accept={evidencesDrawer.type.accept}
                ref={fileRef}
                multiple
                style={styles.files as CSSProperties}
                type="file"
                onChange={(e) => {
                    getEvidences({ e, name: evidencesDrawer?.name })
                }}
            />


            <SnackSimple close={handleCloseSnackbar} open={snackbar.open} type={snackbar.type} message={snackbar.message} />

            <SimpleModal
                open={openModal.open}
                close={handleCloseModal}
                title={openModal.title}
                description={openModal.description}
                children={openModal.children}
                buttonText={t('general.confirm')}
                cancelText={!!openModal?.removeCancel ? undefined : t('general.cancel')}
                back={!!openModal?.removeCancel ? undefined : handleCloseModal}
                loadingButton
                isLoading={isLoadingConfirm}
                next={() => {
                    openModal?.method?.()
                }}
            />
        </Box>
    )
}